import axios from "axios";
import qs from "qs";
import Config from "../config";

// Viqqa Chat (kullanıcının bağlı Viqqa hesabı üzerinden, CRM API vekil olur).
// Yanıtlar: { success, data } ya da { success:false, msg, relink? }.
function authHeaders() {
  return { headers: { Authorization: localStorage.authToken } };
}

let statusPromise = null;

export default {
  rooms() {
    return axios.get(Config.endpoint + "/viqqa/chat/rooms", authHeaders());
  },
  users(q) {
    return axios.get(Config.endpoint + "/viqqa/chat/users", {
      ...authHeaders(),
      params: { q: q || "" }
    });
  },
  // payload: { room_id } ya da { user_id } + { text }
  send(payload) {
    return axios.post(
      Config.endpoint + "/viqqa/chat/send",
      qs.stringify(payload),
      authHeaders()
    );
  },
  // /auth/viqqa/status sonucu sayfa ömrü boyunca bir kez çekilir.
  // Hata olursa önbelleğe alınmaz, sonraki çağrı tekrar dener.
  status() {
    if (!statusPromise) {
      statusPromise = axios
        .get(Config.endpoint + "/auth/viqqa/status", authHeaders())
        .then(resp => resp.data || {})
        .catch(() => {
          statusPromise = null;
          return { enabled: false, linked: null };
        });
    }
    return statusPromise;
  },
  resetStatus() {
    statusPromise = null;
  }
};
